"use client";

import { cn } from "@fatbees/ui-utils";
import * as LabelPrimitive from "@radix-ui/react-label";
import * as React from "react";

export interface LabelProps extends React.ComponentProps<
  typeof LabelPrimitive.Root
> {}

export function Label({ className, ...props }: LabelProps) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "text-sm leading-none block font-medium text-neutral-500 select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
}
